import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';
import { space, SpaceProps, compose } from '@lucid/theme';

export interface CardActionProps extends SpaceProps {
  /** The children to be rendered with the Card.Action. */
  children?: ReactNode;
}

const cardActionStyleProps = compose(space);

const StyledCardAction = styled.div<CardActionProps>(
  ({ theme }) => ({
    label: 'cardAction',
    marginRight: `${theme.space ? theme.space[2] : 0}px`
  }),
  cardActionStyleProps
);

const CardAction: FC<CardActionProps> = (props) => (
  <StyledCardAction {...props} />
);

export { CardAction };
export default CardAction;
